import { Box, ButtonGroup, Button, Text } from '@chakra-ui/react'
import React from 'react'

function Bookmark({ items }) {
  return (
    <>
      <Box>
        {items.map((bookmarkItem) => (
          <>
            <Text>
              <a href={bookmarkItem.url} rel="noreferrer" target="_blank">
                {bookmarkItem.url}
              </a>
            </Text>
            <Text>
              <a href={bookmarkItem.url} rel="noreferrer" target="_blank">
                {bookmarkItem.title}
              </a>
            </Text>
            <Text>{bookmarkItem.description}</Text>
            <ButtonGroup variant="outline">
              {bookmarkItem.topics.map((topic) => (
                <>
                  <Button size="xs">{topic}</Button>
                </>
              ))}
            </ButtonGroup>
          </>
        ))}
      </Box>
    </>
  )
}

export default Bookmark
